// extracted by mini-css-extract-plugin
export var checkIcon = "_e-2";
export var heading = "_e-1";
export var panel = "_e-0";